import styled from 'styled-components';

export const ToggleWrapper = styled.div`
  cursor: pointer;
  border-radius: 25px;
  height: 25px;
  width: 45px;
  background-color: ${({ theme }) => theme.white.a6};
  padding: 2px;
`;

export const ToggleBubble = styled.div<{ $isToggled: boolean }>`
  border-radius: 50%;
  height: 21px;
  width: 21px;
  background-color: ${({ theme }) => theme.white.a10};
  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  margin-left: ${({ $isToggled }) => ($isToggled ? '19px' : '0')};
`;
